"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncNoop = exports.noop = void 0;
var tslib_1 = require("tslib");
var noop = function () {
    var _ = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _[_i] = arguments[_i];
    }
    return null;
};
exports.noop = noop;
var asyncNoop = function () {
    var _ = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _[_i] = arguments[_i];
    }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
        return [2 /*return*/, Promise.resolve({})];
    }); });
};
exports.asyncNoop = asyncNoop;
//# sourceMappingURL=noop.js.map